
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

import api from '@/api';
import { SettingsActions } from '@/store/modules/settings/types';
import { ExcludedPractice } from '@/store/modules/settings/settings';

import Autocomplete, { AutocompleteOption, AutocompletePromise } from '@/components/controls/autocomplete.vue';

export default Vue.extend({
  name: 'BannerStandSettingsForm',
  inject: {
    $validator: '$validator',
  },
  components: {
    Autocomplete,
  },
  data() {
    return {
      cancelTokenSource: undefined as any,
    };
  },
  computed: {
    ...mapState('settings', {
      editable: 'editableSettings',
    }),
    ...mapGetters('settings', {
      isLoading: 'editableSettingsIsLoading',
      isSaving: 'editableSettingsIsSaving',
    }),
    isFetching(): boolean {
      return this.isLoading || this.isSaving;
    },
    excludedPractices(): ExcludedPractice[] {
      return this.editable?.bannerStandExcludedPractices || [];
    },
  },
  methods: {
    ...mapActions('settings', {
      updateEditable: SettingsActions.UPDATE_EDITABLE_SETTINGS,
    }),
    searchPractice(userInput: string): AutocompletePromise {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel();
        this.cancelTokenSource = undefined;
      }

      if (!userInput) {
        return Promise.resolve({
          results: [],
        });
      }

      this.cancelTokenSource = api.getCancelTokenSource();

      return api.practices
        .search(userInput, { cancelToken: this.cancelTokenSource.token })
        .then((response) => {
          // Filter out already excluded practices
          const excludedIds = this.excludedPractices.map((p) => p.id);
          return {
            results: response.data
              .filter((item) => !excludedIds.includes(item.id))
              .map((item) => ({
                label: item.title,
                value: item.id,
              })),
          };
        });
    },
    addPractice(option: AutocompleteOption) {
      if (!option.value) return;

      const newPractice: ExcludedPractice = {
        id: Number(option.value),
        title: option.label,
      };

      const bannerStandExcludedPractices = [...this.excludedPractices, newPractice];
      this.updateEditable({ bannerStandExcludedPractices });
    },
    removePractice(id: number) {
      const bannerStandExcludedPractices = this.excludedPractices.filter((p) => p.id !== id);
      this.updateEditable({ bannerStandExcludedPractices });
    },
  },
});
